import { Box, Button, Code, HStack, Stack } from '@saas-ui/react'
import {
  ErrorComponentProps,
  rootRouteId,
  useMatch,
  useRouter,
} from '@tanstack/react-router'

import { ErrorPage } from './error-page'
import { LinkButton } from './link-button'

const isDev = import.meta.env.DEV

export function DefaultErrorPage({ error }: ErrorComponentProps) {
  const router = useRouter()
  const isRoot = useMatch({
    strict: false,
    shouldThrow: false,
    select: (state) => state.id === rootRouteId,
  })

  return (
    <ErrorPage
      title="Something went wrong"
      description="We've been notified about the problem."
    >
      <Stack w="full" justify="center" gap="8">
        <HStack w="full" justify="center">
          <Button
            variant="surface"
            size="sm"
            onClick={() => {
              router.invalidate()
            }}
          >
            Try again
          </Button>
          {isRoot ? (
            <LinkButton variant="secondary" size="sm" to="/">
              Home
            </LinkButton>
          ) : (
            <LinkButton
              variant="secondary"
              size="sm"
              to="/"
              onClick={(e) => {
                e.preventDefault()
                window.history.back()
              }}
            >
              Go back
            </LinkButton>
          )}
        </HStack>

        {isDev && (
          <Box>
            <Code p="4">
              <pre>{error.stack ?? error.message}</pre>
            </Code>
          </Box>
        )}
      </Stack>
    </ErrorPage>
  )
}
